<template>
  <pt-goods-form class="pt-goods-form__page" :is-edit="is_edit" :id="id"></pt-goods-form>
</template>

<script>
import PtGoodsForm from 'cps/mall-manage/pt-goods-manage/pt-goods-form/withData'
export default {
  name: 'pt-goods-form__view',
  components: {
    'pt-goods-form': PtGoodsForm
  },
  props: {
    isEdit: {
      type: [Boolean, String],
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  },
  created () {
    console.log(this.is_edit)
  }
}
</script>
